import { IPublicEnumInfoElement } from '../lifecycle/PublicEnumInfoLifecycle';

const isTesterFn = () => require('../stores/Omnistore').getOmnistore()?.reoctoStore.isTester; //TODO
const skipTranslationFn = () => require('../stores/Omnistore').getOmnistore()?.reoctoStore.skipTranslation; //TODO

const replacementMap = {
	'##': '#',
	'#n': '\n',
	'#-': '\u2011', // NON-BREAKING HYPHEN
	'#=': '\u00AD', // SOFT HYPHEN
};

function replaceChar(c: string, context: string) {
	const r = replacementMap[c];
	if (r) return r;
	throw new Error('No replacement found for «' + c + '» in «' + context + '»');
}

function transformString(s: string) {
	if (s.indexOf('#') < 0) return s;
	return s.replace(/(#.)/g, replaceChar);
}

function transform(o: { [k: string]: string }) {
	Object.keys(o).forEach(k => o[k] = transformString(o[k]));
	return o;
}

const de = transform({
	GDashboard: 'Dashboard',
	LDashboard: 'Dashboard',
	OrderPage: 'Bestellungen',
	MessagePage: 'Nachrichten',
	LTemplates: 'Listen',
	AdsPage: 'Aktionen',
	Profile: 'Profil',
	MyProfile: 'Mein Profil',
	SupplierOffers: 'Sonderangebote',
	Checkout: 'Checkout',
	GReminders: 'Bestellwecker',
	LReminders: 'Bestellwecker',
	LCatalog: 'Katalog',

	'_multiselect': 'Auswahl',
	'creationTimestamp': 'Angelegt',
	'branchName': 'Location',
	'supplierName': 'Lieferant',
	'customerNo': 'KundenNr.',
	'orderingUserEmail': 'Besteller',
	'status': 'Status',
	'paymentMethod': 'Zahlweise',
	'id': 'Octopus-ID',
	'date': 'Datum',
	'time': 'Uhrzeit',
	'name': 'Bezeichnung',
	'packaging': 'Einheit',
	'itemNo': 'Artikel-Nr.',
	'category': 'Kategorie',
	'pricePair': 'Preis',
	'price': 'Preis',
	'amountToKeep': 'Soll',
	'amountToOrder': 'Bestell#=menge',
	'email': 'E#-Mail Addresse',
	'emailRep': 'E#-Mail (Wiederholung)',
	'firstname': 'Vorname',
	'surname': 'Nachname',
	'title': 'Geschlecht',
	'mr': 'Mann',
	'mrs': 'Frau',
	'divers': 'Divers',
	'street': 'Straße',
	'number': 'Hausnr.',
	'town': 'Stadt',
	'zipcode': 'PLZ',
	'phone': 'Telefon',
	'fax': 'Fax',
	'wantsNewsEmail': 'Newsletter erhalten?',
	'wantsOrderOwnerEmail': 'Eine E#-Mail Benachrichtigung wenn jemand eine Bestellung für Dich gemacht hat?',
	'wantsOrderInitiatorEmail': 'Eine E#-Mail Bestätigung wenn Du eine Bestellung gemacht hast?',
	'wantsOrderAttachment': 'Soll die E#-Mail Bestätigung einen Anhang enthalten?',
	'password': 'Passwort',
	'eancode': 'EAN',
	'availability': 'Verfügbarkeit',
	'deliveryDatetime': 'Lieferdatum/-zeit',
	'pickupDatetime': 'Abholdatum/-zeit',
	'dateAndTime': 'Datum u. Uhrzeit',
	'type': 'Typ',
	'subject': 'Betreff',
	'isRead': 'gelesen',
	'isOwn': 'eigen?',
	'isShared': 'geteilt?',
	'nextAlarm': 'nächste',
	'text': 'Text',
	'addToCart': '',
	'nameAndItemNo': 'Artikelsuche',
	'industry': 'Branche',
	'loginHeading': 'Zugriff auf die Bestellplattform für Gastronomie und Fachgroßhandel',
	'loginTitle': 'Login',

	'order.deliveryKind': 'Lieferart',
	'order.delivery': 'Lieferung',
	'order.pickup': 'Abholung',
	'order.pickupLocation': 'Abholort',
	'order.deliveryDate': 'Lieferdatum',
	'order.deliveryDatetime': 'Lieferdatum und Zeit',
	'order.pickupDate': 'Abholdatum',
	'order.pickupDatetime': 'Abholdatum und Zeit',
	'order.paymentMethod': 'Zahlung',
	'order.message': 'Nachricht an den Lieferanten',
	'order.orderReference': 'Referenz',
	'order.isNotScheduledDay': 'Das gewählte Datum ist nicht in der Liste der uns bekannten Liefertage',
	'order.emptyCart': 'Leerer Warenkorb!',
	'order.emptyCartHeader': 'Keine Artikel vorhanden',
	'order.emptyCartContent': 'Dein Warenkorb ist leer, du wirst wieder zu deiner Liste gebracht',
	'order.notAllowed': 'Keine Orderberechtigung',
	'order.running': 'Bestellprozeß läuft',
	'order.invalidForm': 'Fehlende Eingabe',
	'order.messageTooLong': 'Die Bestellnachricht ist länger als 255 Zeichen.',
	'order.impossible': 'Bestellung nicht möglich',
	'order.success': 'Bestellung erfolgreich',
	'order.failure': 'Bestellung fehlgeschlagen',
	'order.noSupplierEmail': 'Die E#-Mail-Adresse des Lieferanten ist ungültig oder fehlt.',
	'order.successText1': 'Deine Bestellung wurde unter der ID • aufgenommen',
	'order.successText2': 'Deine Bestellung wurde unter den IDs • aufgenommen',
	'order.tooLate': 'Der Bestellzeitpunkt liegt in der Vergangenheit!',
	'order.coupon': 'Gutscheincode',
	'order.popup.line1':'Vielen Dank!',
	'order.popup.line2_p1': 'Wir haben ihre Bestellung für die Location',
	'order.popup.line2_p2': 'mit der octopus ID',
	'order.popup.line2_p3': 'entgegengenommen und leiten diese an',
	'order.popup.line2_p4': 'weiter.',
	'order.popup.line3_p1': 'Sie erhalten eine Bestätigung per E-Mail und können ebenfalls unter ',
	'order.popup.line3_p2': ' alle ihre Bestellungen nachvollziehen.',
	'order.leavingForTemplates': 'zurück zur Liste',

	discontinued: 'Nicht mehr im Sortiment',
	'minicart.noItems': '(leerer Warenkorb)',
	'minicart.items': '• Artikel',
	'minicart.unpricedItems': '• Artikel ohne Preisangabe',
	'endsInDays0': 'Endet heute',
	'endsInDays1': 'Endet morgen',
	'endsInDays2': 'Endet in • Tagen',
	'addAdvertisementToCart': 'Zum Warenkorb hinzufügen',

	'http.offline': 'Du bist offline',
	'http.online': 'Du bist wieder online',
	'http.processingError': 'Fehler!',
	goBackToList:'Zurück zur Liste',
	branch: 'Location',
	supplier: 'Lieferant',
	allSuppliers: '(alle)',
	noData: 'Keine Daten zum Anzeigen',
	noDataAfterFilter: 'Alle Daten wurden ausgefiltert',
	noFiltering: '(alle)',
	'doOrder': 'Bestellen',
	'LTemplates.noData': 'Aktuell sind keine Artikel in Deiner Liste.',
	'SupplierOffers.noData': 'Dieser Lieferant hat aktuell keine Artikel im Sonderangebot',
	'Checkout.noData': 'Aktuell sind keine Artikel in Deinen Warenkörben.',
	'LCatalog.noData': 'Aktuell sind keine Artikel in diesem Katalog.',

	'chart.OrdersByMonth': 'Orders pro Monat',
	'chart.PositionsByMonth': 'Positionen pro Monat',
	'chart.ItemsByMonth': 'Artikel pro Monat',
	'chart.ByDayofweek': 'Orders nach Wochentag',

	'availability.BLUE': '',
	'availability.GREEN': 'im Katalog',
	'availability.YELLOW': 'Verfügbarkeit unbekannt',
	'availability.RED': 'nicht möglich',
	'availability.INFRARED': 'nicht verfügbar',

	'general': 'Allgemein',
	'location': 'Location',

	'team.add': '(neu)',
	'team.extendTeam': 'Neues Teammitglied',
	'team.email': 'E#-mail',
	'team.grantTemplate': 'Bestelliste teilen',
	'team.grantTemplateAndInvite': 'Benutzer zum Octopus einladen',
	'team.invitation': 'Die eingegebene E#-Mail ist uns unbekannt. Klicke noch Mal auf "Speichern", um den Benutzer zum Octopus einzuladen.',
	'team.youAreTheOwner': 'Du bist der Besitzer der Liste und dies kann nicht geändert werden.',
	'team.youAreNotTheOwner': 'Nur der Besitzer der Liste kann die Rechte verwalten.',
	'team.giveUpAccess': 'Zugriff auf die Liste aufgeben',
	'team.reallyGiveUpAccess': 'Zugriff wiklich aufgeben',
	'team.currentAccess': 'Aktuelle Zugriffsrechte',
	'team.newAccess': 'Neue Zugriffsrechte',
	'team.newUserEmail': 'Neues Teammitglied',
	'team.accessSet': 'Zugriffrechte gesetzt',

	'amountStepError': 'Vielfaches benötigt',
	'amountStepExplanation': 'Dieses Artikel kann nur in Vielfachen von • bestellt werden.',
	'amountStepHint': 'Entscheide dich bitte für einen den u.a. Werte.',

	'cancel': 'Abbrechen',
	'save': 'Speichern',
	'saved': 'Gespeichert',
	'delete': 'Löschen',
	'yes': 'ja',
	'no': 'nein',
	'ok': 'OK',
	'somethingWentWrong': 'Ein Fehler ist aufgetreten',
	'editColumns': 'Spalten bearbeiten',

	'createTemplate': 'Neue Liste',
	'withPromocode': 'mit Promocode',
	'withoutPromocode': 'ohne Promocode',
	'promocode': 'Promocode',
	'createTemplate.accept': 'Anlegen',
	'createTemplate.success': 'Liste angelegt',

	'createBranch': 'Neue Location',
	'createBranch.accept': 'Anlegen',
	'createBranch.success': 'Location angelegt',
	'chooseASupplier': 'Wähle zuerst einen Lieferanten',

	'action.logout': 'Abmelden',
	'action.login': 'Anmelden',

	'snack.showingSupplierOffers': 'Lieferantenangebote: Deine ausgewählten Artikel sind nicht unbedingt alle enthalten.',
	'SAVE_FAILED': 'Speicherung fehlgeschlagen!',
	'alreadyThere': 'bereits da',

	'message.read': 'gelesen',
	'message.unread': 'ungelesen',
	'message.makeRead': 'als gelesen markieren',
	'message.makeUnread': 'als ungelesen markieren',
	'message.go.ADVERTISEMENT': 'zum Angebot',
	'message.go.TEMPLATE_REMINDER_ALARM': 'zur Liste',
	'message.go.NEW_TEMPLATE_REMINDER': 'zum Bestellwecker',

	'SetCategory': 'Kategorie zuweisen',
	'SetCategory.selectSomeLines': 'Markiere zuerst eine oder mehrere Zeilen',
	'SetCategory.accept': 'zuweisen',
	'SetCategory.success': 'Die Kategorie wurde zuweisen.',
	'SetCategoryToNItems1': 'Wähle die Kategorie für den gewählten Artikel',
	'SetCategoryToNItems2': 'Wähle die Kategorie für die • gewählten Artikel',

	'addToTemplate': 'Hinzufügen',
	'addedToTemplate': 'Artikel wurde hinzugefügt.',
	'alreadyInTemplate': 'Artikel ist bereits in der Liste.',

	'clearMultiselected': 'Die Markierung wurde aufgehoben',
	hint: 'Hinweis',
	'updateCart':'Möchten Sie den Warenkorb wirklich aktualisieren?',
	'templDetails': 'Liste bearbeiten',
	'editBranch': 'Location',
	'editSupplier': 'Lieferant',
	'editTemplate': 'Kundennummer',
	'titleEditBranch': 'Location bearbeiten',
	'titleEditSupplier': 'Lieferanten bearbeiten',
	'titleEditTemplate': 'Liste bearbeiten',
	'TeamPage': 'Team',
	'onlyTheOwnerCanDoThis': 'Das darf nur der Besitzer',
	register: 'Neuen Account anlegen',
	titleRegistration: 'Neuen Account anlegen',
	loginLinkText: 'Login',
	subHeadingRegistration: 'Mit meiner Registrierung stimme ich der Datenschutzerklärung und den Allgemeinen Nutzungsbedingungen zu.',
	titleRegistrationDone: 'Registrierung abgeschlossen',
	startRegistration: 'Registrieren',
	registrationDoneContent: 'Wir haben dir eine E‑Mail mit einen Link zugeschickt, mit dem du dein Passwort setzen kannst.',
	recoverPassword: 'Passwort vergessen?',
	confirmRecoverPasswordHeading: 'Bitte Passwort-Wiederherstellung bestätigen"',
	confirmRecoverPassword: 'Sollen wir dir eine E#-Mail an "•" zuschicken, mit dem du dein Passwort setzen kannst?',
	recoverPasswordEmailSent: 'E#-Mail verschickt',
	welcomeToReocto: 'Version •',
	nameOfReocto: 'Version •',
	setPassword: 'Passwort setzen',
	passwordRep: 'Bestätigung',
	emptyPassword: 'Das Passwort ist leer.',
	mismatchedPassword: 'Die Felder stimmen nicht überein.',
	titleSetPassword: 'Passwort setzen',
	setPasswordSuccess: 'Passwort gesetzt',
	subHeadingSetPassword: ' ',
	'location.name':'Name deiner Location',
	'location.house_number': 'Hausnummer',
	'unknownStep':'Unknown step',
	'list.step1': 'Location anlegen',
	'list.step2': 'Lieferanten hinzufügen',
	'list.step3': 'Liste fertigstellen',
	'chooseLocation': 'Wähle eine Location',
	'selectedLocation': 'Ausgewählt',
	'noSupplierText': 'Kein Lieferant gefunden',
	'supplier.name':'Name deines Lieferanten',
	'supplier.customerNumber':'deine Kundennummer',
	'supplier.email':'E#-Mailaddresse deines Lieferanten',
	'supplier.industry': 'Branche',
	'supplier.industryInfoText': 'Gebe hier bitte die Branche deines Lieferanten ein',
	'letsGo':'LOS GEHTS!',
	'next':'Weiter',
	'back':'Zurück',
	'finish':'Fertigstellen',
	'reset':'RESET',
	'allStepsDone':'All steps completed - you & apos; re finished',
	'location_add.step_1_0':'Bei Octopus Order machst du deine Bestellungen mit Listen. Das erspart es dir dich jedes Mal durch das gesamte Sortiment deiner Händler zu wühlen, bis du zu den Artikeln kommst die du wirklich bestellen willst. Es gibt pro Lieferant und einer deiner Locations gibt es immer eine Liste und das Anlegen einer Liste 	ist geht einfach. Denn wenn Dein Lieferant mit 	uns zusammenarbeitet, dann hat er bereits alle 	Artikel für dich bei uns hinterlegt! Los gehts!',
	'location_add.step_1_1':'Das Anlegen einer Liste beginnt mit der Location für die Du bestellen willst. Gib hier die Details deiner Location ein. Der Name der Location wird auch Teil des Namens deiner Liste, damit du dich bei mehreren Listen auch zurechtfindest.',
	'location_add.step_1_2': 'In wenigen Schritten zu Deiner Liste! Folls du die Location für die du bestellen willst schon angelegt hast, wähle sie einfach aus und klicke dann auf weiter. Falls nicht, dann kannst du vorher einfach eine neue Location hinzufügen.',
	'location_add.step_2_0': 'Hast du einen Promocode für Octopus von Deinem Lieferanten erhalten?',
	'location_add.step_2_1': 'Wenn du von deinem Lieferanten einen Promo Code erhalten hast, dann gebe ihn bitte hier ein und driicke auf Fertig.',
	'location_add.step_2_2': 'Mein Lieferant ist nicht in dieser Liste zu finden',
	'location_add.step_2_2_1_p1': 'Bitte gebe hier deine Kundennummer und Postleitzahl ein unter der du bei',
	'location_add.step_2_2_1_p2': 'bekannt bist. Falls Du die Daten nicht weisst, auf einer Rechnung sollten diese zu finden sein.',
	'location_add.step_3_0_p1': 'Super! Du hast jetzt Deine Liste für',
	'location_add.step_3_0_p2': 'angelegt und kannst ab sofort bei',
	'location_add.step_3_0_p3': 'bestellen!',
	harmoPrimarySecondary: 'Primär/sekundär',
	harmonizerName: 'Bearbeiter',
	harmoStatus: 'Status',
	itemGroup1: 'Warengruppe',
	itemGroup2: 'Artikelkategorie',
	vendor: 'Hersteller',
	vendorItem: 'Herstellerartikel',
	wholesaler: 'Händler',
	wholesalerItem: 'Händlerartikel',
	selectSupplier: 'Händler',
	selectMasterItem: 'Artikel',
	filterOnBrand: 'Filtern',
	ignoreBrand: 'Markenfilter ignorieren',
	selectBrand: 'Markenfilter',
	harmo_all: '(alle)',
	nameAndItemNoAndEancode: 'Bez./Artikel-Nr./EAN',
	'relinked-deleted': 'Aufgehoben',
	'relinked-primary': 'Primär',
	'relinked-secondary': 'Sekundär',
	'relink-deleted': 'Aufheben',
	'relink-primary': 'Primär',
	'relink-secondary': 'Sekundär',
	MasterItemImportDialog: 'Import von Master-Katalogen',
	OutletImportDialog: 'Import von Outlets',
	HarmoPage: 'Artikelkataloge',
	AdmAdPage: 'Aktionen',
	OutletPage: 'Outlets',
	SendMessagePage: 'Nachrichten',
	AdmCouponPage: 'Coupons',
	dataManagement: 'Datenpflege',
	adsManagement: 'Aktionsverwaltung',
	hideUnmatched: 'nur verknüpfte',
	hideMatchedElsewhere: 'blockierte ausblenden',
	linkedElsewhere: 'blockiert',
	unlinkOrRelink: 'Verknüpfung aufheben/ändern',
	STRING: 'im Text',
	WORD_START: 'am Wortanfang',
	WORD: 'als ganzes Wort',
	execute: 'Ausführen',
	excelImportFile: 'Excel-Datei',
	pleaseSelectFile: 'bitte wählen',
	importConfirmation: 'Import-Bestätigung',
	importError: 'Import-Fehler',
	EditBrandDialog: 'Suchkriterien bearbeiten',
	ownerEmail: 'Besitzer-E#-Mail',
	facebookUrl: 'Facebook-URL',
	homepageUrl: 'Home-URL',
	categories: 'Kategorien',
	brand: 'Markenfilter',
	description: 'Beschreibung',
	age: 'Qualität',
	vol: 'Vol.-%',
	origin: 'Herkunftsland',
	container: 'Basis-Einheitencode',
	bundle: 'Inhalt Packeinheit',
	amount: 'Inhalt Menge',
	unit: 'Inhalt Art',
	AutoHarmonizerDialog: 'Automatisches GTIN-basiertes Matching',
	AutoHarmonizerDialogResult: 'Ergebnis',
	allMasterSuppliers: 'Alle Hersteller',
	allSlaveSuppliers: 'Alle Händler',
	someIdRequired: 'Mindestens eine Einschränkung wird benötigt',
	executed: 'Ausgeführt',
	EditOutletDialog: 'Outlet bearbeiten',
	newCategory: 'Neue Kategorie',
	pleaseSelect: 'Bitte wählen',
	wholesalers: 'Händler',
	BrandPage: 'Marken',
	searchResults: 'Suchergebnisse',
	'AdmAdDialog_create': 'Aktion anlegen',
	'AdmAdDialog_update': 'Aktion bearbeiten',
	'AdmAdDialog_0': 'Basisdaten',
	'AdmAdDialog_1': 'Produktinformation',
	'AdmAdDialog_2': 'Aktionsdetails',
	isDeleted: 'Gelöscht?',
	advertizer: 'Hersteller',
	validSince: 'Gültig ab',
	validUntil: 'Gültig bis',
	variationsBase: 'Artikelauswahl',
	variationsMore: 'Variationen',
	imageLink: 'Bild hochladen',
	badgeTitle: 'Badge-Titel',
	badgeSubtitle: 'Badge-Untertitel',
	badgeColor: 'Badge-Farbe',
	amountStep: 'Bestellmenge',
	amountMax: 'Maximale Bestellmenge (0=uneingeschränkt)',
	oncePerBranch: 'Einmal pro Outlet',
	viaTemplate: 'Über Liste zu bestellen',
	nInitialItems: 'Verfügbare Menge (0=uneingeschränkt)',
	supplierIdsAsString: 'Teilnehmende FGHs',
	pleaseFixItFirst: 'Korrigiere bitte das Feld •',
	create: 'Anlegen',
	showNonMastersOnly: 'Nur Hersteller-Artikel ohne Verknüpfungen',
	brandSpellings: 'Alternative Schreibweisen',
	harmoInfo: 'Harmonisiert',
	AdmUserPage: 'Benutzer',
	AdmSupplierPage: 'Lieferanten',
	AdmSupplierItemPage: 'Lieferanten-Artikel',
	AdmPretemplatePage: 'Pretemplates',
	AdmPretemplateItemPage: 'Pretemplate-Artikel',
	AdmTemplatePage: 'Listen',
	ImpressumPage: 'Impressum',
	AdmTemplateItemPage: 'Listen-Artikel',
	isHarmonized: 'fertig',
	isUnharmonized: 'offen',
	duplicatedVariation: 'Duplizierte Variation',
	emptyVariation: 'Leere Variation',
});

const onMissing = (s: string) => {
	return isTesterFn() ? '!!' + s : s;
};

export const transl = (s: string, ...args: Array<any>) => {
	const r = skipTranslationFn() ? s : de[s];
	if (r === undefined) return onMissing(s);
	if (!args.length) return r;
	const list = r.split('•');
	const result = [list[0]];
	for (let i = 0; i < args.length; ++i) {
		result.push(args[i]);
		result.push(list[i + 1]);
	}
	return result.join('');
};

transl.applyPublicEnumInfo = (a: Array<IPublicEnumInfoElement>) => {
	a.forEach(({ id, members, translations }) => {
		if (!translations) return; // TODO
		members.forEach((m, i) => de[id + '.' + m] = translations[i]);
	});
};
